import React                from 'react';

import Alert                from '../utils/Alert';
import * as MenuItem        from '../components/MenuItem';

interface Props {
}

interface State {
}

export default class DoSomething extends React.Component<Props,State> {
    private alert               : Alert = new Alert();
    constructor( props:Props ) {
        super(props);
        this.state = {
        };
    }
    render() {
        return MenuItem.withMenuItem("New ADA Application",( alert_ ) => {
            this.alert = alert_;
            return (
                <div className="content">
                    This will do something
                    <div className="btn-wrap">
                        <button className="btn-theme btn-min" onClick={(e:React.MouseEvent<HTMLButtonElement>)=>{
                            this.alert.set(`not ready`,5000);
                        }}>Do Something</button>
                    </div>
                </div>
            );
        });
    }
}
